import styled from 'styled-components';

export const StyledMainContent = styled.main`
  height: 100%;
`;
